<template>
  <Category
    cate-name="tripeditor"
    category-name="TRiP EDiTOR賞"
    category-intro="「旅も人生も、もっと楽しく編集できる」をテーマにしたWebメディア「TRiP EDiTOR」が厳選。読めばきっと旅に出かけたくなるメルマガをセレクトしました。"
  />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
